<template>
    <div class="row">
        <div class="col-12">
            <div class="row gutter-sm" v-if="step === 'area'">
                <div class="col-12 text-center text-weight-medium">
                    {{ $t('select_a_area') }}
                </div>

                <div v-if="areas.length" class="col-6" v-for="(area, index) in areas" :key="index" @click="selectArea(area.value)">
                    <q-card class="bg-primary button-style">
                        <div class="row q-pl-md q-pt-md">
                            <div class="col-12 q-mb-sm">
                                <q-icon name="fas fa-sitemap" size="2rem" color="white" />
                            </div>

                            <div class="col-12 q-subheading text-white">
                                {{ $t(area.label) }}
                            </div>
                        </div>
                    </q-card>
                </div>

                <div v-else class="col-12">
                    <q-card class="bg-primary button-style" @click.native="selectArea('all')">
                        <div class="row q-pl-md q-pt-md">
                            <div class="col-12 q-mb-sm">
                                <q-icon name="fas fa-sitemap" size="2rem" color="white" />
                            </div>

                            <div class="col-12 q-subheading text-white">
                                {{ $t('all_f') }}
                            </div>
                        </div>
                    </q-card>
                </div>

                <div class="col-12 text-center text-weight-medium" v-if="groups_user.length > 0 && isPopOrSeven">
                    {{ $t('select_a_group') }}
                </div>
                <template  v-if="isPopOrSeven">
                    <div class="col-6" v-for="(group, index) in groups_user" :key="`${index}-g`" @click="selectGroup(group.value)">
                        <q-card class="bg-primary button-style">
                            <div class="row q-pl-md q-pt-md">
                                <div class="col-12 q-mb-sm">
                                    <q-icon name="fas fa-sitemap" size="2rem" color="white" />
                                </div>

                                <div class="col-12 q-subheading text-white">
                                    {{ $t(group.label) }}
                                </div>
                            </div>
                        </q-card>
                    </div>
                </template>
            </div>

            <div class="row gutter-sm" v-if="step === 'category'">
                <div class="col-12 text-center text-weight-medium">
                    {{ $t('select_a_category') }}
                </div>

                <div class="col-12">
                    <q-card class="bg-primary button-style" @click.native="selectCategory('all')">
                        <div class="row q-pl-md q-pt-md">
                            <div class="col-12 q-mb-sm">
                                <q-icon name="fas fa-sitemap" size="2rem" color="white" />
                            </div>

                            <div class="col-12 q-subheading text-white">
                                {{ $t('all_f') }}
                            </div>
                        </div>
                    </q-card>
                </div>

                <div class="col-6" v-for="(category, index) in categories" :key="index" @click="selectCategory(category.value)">
                    <q-card class="bg-primary button-style">
                        <div class="row q-pl-md q-pt-md">
                            <div class="col-12 q-mb-sm">
                                <q-icon :name="category.icon" size="2rem" color="white" />
                            </div>

                            <div class="col-12 q-subheading text-white">
                                {{ $t(category.label) }}
                            </div>
                        </div>
                    </q-card>
                </div>

                <div class="col-12 text-center">
                    <q-btn :label="$t('select_area')" color="tertiary" icon="fas fa-chevron-left" @click="backToArea()" />
                </div>
            </div>

            <div class="row gutter-sm" v-if="step === 'tags'">
                <div class="col-12 text-center text-weight-medium">
                    {{ $t('select_tags') }}
                </div>

                <div class="col-12">
                    <q-card class="bg-primary button-style" @click.native="selectTags('all')">
                        <div class="row q-pl-md q-pt-md">
                            <div class="col-12 q-mb-sm">
                                <q-icon name="fas fa-sort-amount-down-alt" size="2rem" color="white" />
                            </div>

                            <div class="col-12 q-subheading text-white">
                                {{ $t('none') }}
                            </div>
                        </div>
                    </q-card>
                </div>

                <div class="col-12" v-for="(tag, index) in tags" :key="index">
                    <q-card class="bg-primary" @click.native="selectTags(tag.value)">
                        <div class="row q-pl-md q-py-md">
                            <div class="col-12 q-subheading text-white">
                                <q-checkbox v-model="selected_tags" :val="tag.value" :label="tag.label" color="white" class="checkbox-filter" />
                            </div>
                        </div>
                    </q-card>
                </div>

                <div class="col-12 text-center">
                    <q-btn class="full-width" color="secondary" :label="$t('apply_filter')" icon="fas fa-filter" @click="applyFilter()" />
                </div>

                <div class="col-12 text-center">
                    <q-btn :label="$t('select_category')" color="tertiary" icon="fas fa-chevron-left" @click="backToCategory()" />
                </div>
            </div>

            <q-list v-if="step === 'showing_files'" class="bg-white">
                <q-collapsible class="filter" icon="fas fa-filter" :label="$t('filter')" :opened="!$q.platform.is.mobile ? true : false">
                    <q-list no-border>
                        <q-item>
                            <q-item-main>
                                <q-search v-model="search" :placeholder="$t('search')" icon="fas fa-search" @input="changeFilter('search')" :debounce="600" />
                            </q-item-main>
                        </q-item>
                    </q-list>

                    <q-list no-border link>
                        <q-list-header>{{ $t('extensions') }}</q-list-header>

                        <q-item tag="label" v-for="(extension, index) in extensions" :key="index">
                            <q-item-side>
                                <q-checkbox v-model="selected_extensions" :val="extension" @input="changeFilter('extension')" />
                            </q-item-side>
                            <q-item-main>
                                <q-item-tile label class="text-weight-light uppercase">
                                    <q-icon :name="$extensionIcon(extension)" size="1.5rem" /> {{ extension }}
                                </q-item-tile>
                            </q-item-main>
                        </q-item>
                    </q-list>
                </q-collapsible>
            </q-list>

            <div class="row gutter-sm q-my-sm" v-if="step !== 'area'">
                <div class="col-12 text-center">
                    <span class="cursor-pointer" @click="clearFilters()">
                        {{ $t('restart_filters') }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            step: 'area',
            search: '',
            selected_areas: '',
            selected_groups: '',
            selected_categories: [],
            selected_tags: [],
            selected_extensions: [],
            areas: [],
            categories: [],
            tags: []
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            search_store: 'libraries/search',
            extensions: 'site_lists/library_file_extensions',
            store_search: 'libraries/search',
            store_selected_areas: 'libraries/selected_areas',
            store_selected_groups: 'libraries/selected_groups',
            store_selected_categories: 'libraries/selected_categories',
            store_selected_tags: 'libraries/selected_tags',
            store_selected_extensions: 'libraries/selected_extensions',
            groups_user: 'site_lists/groups_user',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        isPopOrSeven() {
            if (process.env.PROJECT_FOLDER === 'academiapoptrade' || process.env.PROJECT_FOLDER === 'academiaseventrade') return false
            return true
        },
    },

    methods: {
        fetchAreas() {
            this.$q.loading.show()

            this.$axios.get('/etraining_library_files/files/areas_filter/', this.getHeader)
            .then(response => {
                this.areas = response.data ? response.data.map(a => {
                    return { label: a.name, value: a.id }
                }) : []
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        fetchCategories() {
            this.$q.loading.show()

            this.categories = []

            this.$axios.get(`/etraining_library_files/files/area_categories_filter/?areas=${this.selected_areas}`, this.getHeader)
            .then(response => {
                response.data.map(a => {
                    this.categories.push({ label: a.title, value: a.id, icon: a.icon })
                })

                this.step = 'category'
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        fetchTags() {
            this.$q.loading.show()

            this.tags = []

            this.$axios.get(`/etraining_library_files/files/area_category_tags_filter/?categories=${this.selected_categories}`, this.getHeader)
            .then(response => {
                response.data.map(a => {
                    this.tags.push({ label: a.title, value: a.id })
                })

                this.step = 'tags'
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        selectArea(value) {
            if (value === 'all') {
                this.step = 'showing_files'
                this.$emit('showFiles', true)
                this.setFilter()
            }
            else {
                this.selected_areas = value
                this.fetchCategories()
            }
        },

        selectGroup(value) {
            this.selected_groups = value
            this.step = 'showing_files'
            this.$emit('showFiles', true)
            this.setFilter()
        },

        selectCategory(value) {
            if (value === 'all') {
                this.step = 'showing_files'
                this.$emit('showFiles', true)
                this.setFilter()
            }
            else {
                this.selected_categories = value
                this.fetchTags()
            }
        },

        selectTags(value) {
            if (value === 'all') {
                this.step = 'showing_files'
                this.$emit('showFiles', true)
                this.setFilter()
            }
            else {
                if (this.selected_tags.includes(value)) {
                    let index = this.selected_tags.indexOf(value)
                    if (index > -1) this.selected_tags.splice(index, 1)
                }
                else this.selected_tags.push(value)
            }
        },

        applyFilter() {
            this.step = 'showing_files'
            this.$emit('showFiles', true)
            this.setFilter()
        },

        setFilter() {
            this.$store.dispatch('libraries/SET_FILTERS', [this.search, this.selected_areas, this.selected_categories, this.selected_groups, this.selected_tags, this.selected_extensions])
            this.$emit('changeFilter')
        },

        clearFilters() {
            this.$emit('showFiles', false)

            this.step = 'area'
            this.search = ''
            this.selected_areas = ''
            this.selected_groups = ''
            this.selected_categories = ''
            this.selected_tags = []
            this.selected_extensions = []

            this.fetchAreas()

            this.$store.dispatch('libraries/SET_FILTERS', ['', 'all', 'all', '', [], []])
        },

        getExtensionIcon(ext) {
            switch(ext) {
                case 'mp4': return 'far fa-file-video'
                break

                case 'pdf': return 'far fa-file-pdf'
                break

                case 'png':
                case 'jpg':
                case 'gif': return 'far fa-file-image'
                break

                case 'zip':
                case 'rar':
                case 'gzip':
                case 'tz': return 'far fa-file-archive'
                break

                case 'xlsx':
                case 'xls': return 'far fa-file-excel'
                break

                case 'docx':
                case 'doc': return 'far fa-file-word'
                break

                case 'pptx':
                case 'ppt': return 'far fa-file-powerpoint'

                default: return 'far fa-file'
                break
            }
        },

        changeFilter() {
            this.$store.dispatch('libraries/SET_FILTERS', [this.search, this.selected_areas, this.selected_categories, this.selected_tags, this.selected_extensions])
            this.$emit('changeFilter')
        },

        backToArea() {
            this.step = 'area'
            this.selected_areas = ''
            this.selected_categories = ''
        },

        backToCategory() {
            this.step = 'category'
            this.selected_categories = ''
            this.selected_tags = []
        }
    },

    created() {
        this.fetchAreas()

        if (this.$route.params.name) {
           this.step = 'showing_files'
        }
    },

    watch: {
        $route: function (to, from) {
            if (this.$route.params.name) {
                this.step = 'showing_files'
            }
        },

    },
}
</script>

<style lang="stylus" scoped>
.button-style
    min-height 100px
    border-radius 6px
</style>
